<ycn-modal-base
        [extraModalClasses]="'modal-sm'"
        [open]="state.modalOpen"
        (closeModalHandler)="closeModal()">
    <ycn-simple-modal-header
            [header]="'Help'"
            (closeModalHandler)="closeModal()">
    </ycn-simple-modal-header>
    <div class="modal-body">
        <div class="modal-section" *ngIf="state.loading">
            <div class="loader">
                <div class="loader-message">Loading...</div>
                <div class="loader-spinner"></div>
            </div>
        </div>
        <div class="modal-section" *ngIf="state.helpModalInfo">
            <div class="modal-message" [innerHTML]="state.helpModalInfo.content"></div>
        </div>
        <div class="modal-section" *ngIf="state.error">
            <div class="modal-message">An error has occurred.</div>
        </div>
    </div>
</ycn-modal-base>
